import { FormText } from "Components/Features/CheckPrice/Products/productInterfaces";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { useComponentTexts } from "Store/texts/hooks";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { CabinProductDetailsFormValues } from "../../ProductDetails/cabinProductDetailsInterfaces";

interface Props {
  formProps: FormikProps<CabinProductDetailsFormValues>;
  productText: FormText;
  lang: TextLanguage;
}

export const CrawlSpaceQuestion = ({
  formProps,
  productText,
  lang,
}: Props): React.ReactElement => {
  const [{ boolean }] = useComponentTexts();
  return (
    <RadioButtonTrueFalse
      name="hasCrawlspace"
      id="hasCrawlspace"
      hint={productText.crawlspace.hint[lang]}
      label={productText.crawlspace.label[lang]}
      options={[
        {
          label: boolean.yes[lang],
          value: true,
          id: "hasCrawlspace-yes",
        },
        {
          label: boolean.no[lang],
          value: false,
          id: "hasCrawlspace-no",
        },
      ]}
      direction="vertical"
      error={getError("hasCrawlspace", formProps)}
    />
  );
};
